



























import { Component, Vue, Prop } from 'vue-property-decorator'
import Axios from 'axios'
import { Playlist, PLAYLIST_TYPES } from '@/classes/playlist'
import { getPlaylistsFlattenedRecursive } from '@/helpers/library'
import * as _ from 'lodash'
import { USAGE_STAT_FEATURES } from '../../../../../system/usage-stats'

@Component({
  components: {
    BaseAction: require('./_Base').default
  }
})
export default class Create extends Vue {
  @Prop()
  selectedPlaylists: Playlist[]

  name: string = ''
  dedupe: boolean = true

  get selectedPlaylist(): Playlist | null {
    return this.selectedPlaylists.length === 1 ? this.selectedPlaylists[0] : null
  }

  get selectedTrackIds(): string[] {
    const trackIds = _.concat([], ...getPlaylistsFlattenedRecursive(this.selectedPlaylists).map(x => x.tracks))

    if (this.dedupe) {
      return _.uniq(trackIds)
    } else {
      return trackIds
    }
  }

  get anyPlaylistIsFolder(): boolean {
    return this.selectedPlaylists.some(x => x.type === PLAYLIST_TYPES.Folder)
  }

  get validation(): { message?: string, valid: boolean } {
    if (this.selectedPlaylists.length < 2) return { message: 'Please select the playlists you want to merge', valid: false }
    if (!this.name) return { message: 'Please enter a playlist name', valid: false }

    return { valid: true }
  }

  async save() {
    if (!this.validation.valid) return

    window.addUsageStat(USAGE_STAT_FEATURES.ManagePlaylist, 'merge', 'confirm', {
      dedupe: this.dedupe,
      amount: this.selectedPlaylists.length
    })

    return Axios.post('/playlist/create', { // TODO: target position?
      name: this.name,
      trackIds: this.selectedTrackIds,
      position: 'below',
      positionAnchorId: this.selectedPlaylists[this.selectedPlaylists.length - 1]._id
    }).then((res) => {
      this.$buefy.notification.open('Merged playlists')

      return res
    })
  }

  mounted() {
    (this.$refs as any).name.focus()
  }
}
